import React from "react";
import { StyledPaper } from "../../customComponents/styled/styledPaper";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StaffRegForm from "./new-staff-form";
import StaffList from "./StaffList";

function Staff() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTab, setActiveTab] = React.useState("StaffRegForm");
  const [openMenu, setOpenMenu] = React.useState(true);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (isMobile) {
      setOpenMenu(false);
    }
  };

  return (
    <Grid container columnSpacing={4} sx={{ padding: { xs: "0", sm: "0 20px" } }}>
      <Grid item xs={12} sm={3} md={2} sx={{ textAlign: "center" }}>
        {isMobile ? (
          <Accordion
            expanded={openMenu}
            onChange={(_, expanded) => setOpenMenu(expanded)}
            disableGutters
            sx={{ mb: 1 }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Menu</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <StyledPaper sx={{ paddingTop: "15px", paddingBottom: "25px" }}>
                <Typography
                  sx={{
                    fontSize: "15px",
                    borderBottom: "1px solid lightgrey",
                    paddingBottom: "12px",
                    width: "100%",
                  }}
                  variant="formHeading"
                >
                  MENU
                </Typography>

                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "12px",
                    borderRadius: "0",
                    color: "primary.safeOnLight",
                    backgroundColor: "white",
                    textTransform: "none",
                    padding: "7px 15px",
                    textAlign: "start",
                    border: "none",
                    "&:hover": {
                      backgroundColor: "rgba(211,211,211, 0.2)",
                      border: "none",
                      cursor: "pointer",
                    },
                    "&.activeTab": {
                      boxShadow: "none",
                      backgroundColor: "primary.main",
                      color: "primary.contrastText",
                      border: "none",
                    },
                  }}
                  className={activeTab === "StaffRegForm" && "activeTab"}
                  onClick={() => handleTabChange("StaffRegForm")}
                >
                  Add New Staff
                </Typography>

                <Typography
                  sx={{
                    width: "100%",
                    fontSize: "12px",
                    borderRadius: "0",
                    color: "primary.safeOnLight",
                    backgroundColor: "white",
                    textTransform: "none",
                    padding: "7px 15px",
                    textAlign: "start",
                    border: "none",
                    "&:hover": {
                      backgroundColor: "rgba(211,211,211, 0.2)",
                      border: "none",
                      cursor: "pointer",
                    },
                    "&.activeTab": {
                      boxShadow: "none",
                      backgroundColor: "primary.main",
                      color: "primary.contrastText",
                      border: "none",
                    },
                  }}
                  className={activeTab === "StaffList" && "activeTab"}
                  onClick={() => handleTabChange("StaffList")}
                >
                  Staff List
                </Typography>
              </StyledPaper>
            </AccordionDetails>
          </Accordion>
        ) : (
          <StyledPaper sx={{ paddingTop: "15px", paddingBottom: "25px" }}>
            <Typography
              sx={{
                fontSize: "15px",
                borderBottom: "1px solid lightgrey",
                paddingBottom: "12px",
                width: "100%",
              }}
              variant="formHeading"
            >
              MENU
            </Typography>

            <Typography
              sx={{
                width: "100%",
                fontSize: "12px",
                borderRadius: "0",
                color: "primary.safeOnLight",
                backgroundColor: "white",
                textTransform: "none",
                padding: "7px 15px",
                textAlign: "start",
                border: "none",
                "&:hover": {
                  backgroundColor: "rgba(211,211,211, 0.2)",
                  border: "none",
                  cursor: "pointer",
                },
                "&.activeTab": {
                  boxShadow: "none",
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                  border: "none",
                },
              }}
              className={activeTab === "StaffRegForm" && "activeTab"}
              onClick={() => handleTabChange("StaffRegForm")}
            >
              Add New Staff
            </Typography>

            <Typography
              sx={{
                width: "100%",
                fontSize: "12px",
                borderRadius: "0",
                color: "primary.safeOnLight",
                backgroundColor: "white",
                textTransform: "none",
                padding: "7px 15px",
                textAlign: "start",
                border: "none",
                "&:hover": {
                  backgroundColor: "rgba(211,211,211, 0.2)",
                  border: "none",
                  cursor: "pointer",
                },
                "&.activeTab": {
                  boxShadow: "none",
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                  border: "none",
                },
              }}
              className={activeTab === "StaffList" && "activeTab"}
              onClick={() => handleTabChange("StaffList")}
            >
              Staff List
            </Typography>
          </StyledPaper>
        )}
      </Grid>

      <Grid item xs={12} sm={9} md={10}>
        {activeTab === "StaffRegForm" && <StaffRegForm />}
        {activeTab === "StaffList" && <StaffList />}
      </Grid>
    </Grid>
  );
}

export default Staff;
